import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, PLATFORM_ID, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { apiErrorInterceptor } from './shared/interceptors/api-error.interceptor';
import { idTokenInterceptor } from './shared/interceptors/id-token.interceptor';
import { performanceDiagnosticsInterceptor } from './shared/interceptors/performance-diagnostics.interceptor';
import { sessionSettingsInterceptor } from './shared/interceptors/session-settings.interceptor';
import { validationWorkbenchApiTraceInterceptor } from './shared/interceptors/validation-workbench-api-trace.interceptor';

import { MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalService, MsalGuard, MsalInterceptor, MsalBroadcastService } from '@azure/msal-angular';
import { MSALInstanceFactory, MSALGuardConfigFactory, MSALInterceptorConfigFactory } from './auth-config';

// Only register ag-grid modules in browser environment
if (typeof window !== 'undefined') {
  ModuleRegistry.registerModules([
    AllCommunityModule
  ]);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([performanceDiagnosticsInterceptor, sessionSettingsInterceptor, idTokenInterceptor, apiErrorInterceptor, validationWorkbenchApiTraceInterceptor])
    ),
    /*{
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },*/
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    provideRouter(routes),
    // provideClientHydration(withEventReplay())
  ]
};
